import script from "./SupportTicketModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportTicketModal.vue?vue&type=script&setup=true&lang=js"

import "./SupportTicketModal.vue?vue&type=style&index=0&id=1a88e757&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a88e757"]])

export default __exports__